import ScaleModeType from "@/pages/takeoff/context/project-organisation/models/enums/file-content-type";
import KnownScaleContent from "@/pages/takeoff/context/project-organisation/models/known-scale-content";
import UserDefinedContent from "@/pages/takeoff/context/project-organisation/models/user-defined-content";


const fileContentParser = function (mode: ScaleModeType, content: Record<string, unknown>) {
    switch (mode) {
        case ScaleModeType.KNOWN:
            return KnownScaleContent.fromJSON(content);
        case ScaleModeType.USER:
            return UserDefinedContent.fromJSON(content);
        default:
            throw new Error(`Mode inconnu: ${mode}`);
    }
}

export default fileContentParser;